'use strict';

import Isotope from 'isotope-layout';
import imagesLoaded from 'imagesloaded';
import { debounce } from './helpers/utils';

export function init() {
    const wrapper = document.querySelector('.grid-wrapper');
    if (!wrapper) return;

    const iso = new Isotope(wrapper, {
        itemSelector: '.grid-elem',
        layoutMode: 'masonry',
        percentPosition: true,
        masonry: {
            columnWidth: '.grid-column-sizer',
            gutter: 0,
        },
    });

    // Re-layout as each image loads
    const imgLoad = imagesLoaded(wrapper);
    imgLoad.on('progress', () => {
        iso.layout();
    });

    // Re-layout on resize (debounced)
    window.addEventListener('resize', debounce(() => {
        iso.layout();
    }, 150));
}
